import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { q } from '../../api/queries';
import { Empty, Mono, Page, PageHeader, Panel, Skeleton, Table, col } from '@bounded/ui/primitives';
import { ErrorNotice } from '@bounded/ui/state';
import { useFormat, useT } from '../../i18n';

export const Route = createFileRoute('/_app/audit')({ component: Audit });

function Audit() {
  const t = useT(); const m = t.audit; const f = useFormat();
  const audit = useQuery(q.audit());
  const items = [...(audit.data?.items ?? [])].sort((a, b) => b.created_at - a.created_at);
  return (
    <Page>
      <PageHeader title={m.title} description={m.description} />
      {audit.error ? <ErrorNotice error={audit.error} onRetry={() => void audit.refetch()} /> : (
        <Panel>
          {!audit.data ? <div className="p-4"><Skeleton className="h-40" /></div> : !items.length ? <Empty title={m.empty} /> : (
            <Table minWidth="48rem" head={[{ label: m.when }, { label: m.action }, { label: m.target }, { label: t.labels.reason }, { label: m.actor, className: col.hideMd }]}>
              {items.map((e) => (
                <tr key={e.id}>
                  <td className="whitespace-nowrap text-graphite" title={f.dateTime(e.created_at)}>{f.ago(e.created_at)}</td>
                  <td className="whitespace-nowrap">{m.actions[e.action] ?? <code>{e.action}</code>}</td>
                  <td><Target action={e.action} id={e.target_id} /></td>
                  <td className="max-w-[40ch] [overflow-wrap:anywhere]">{e.reason}</td>
                  <td className={col.hideMd}><Link to="/accounts/$accountId" params={{ accountId: e.actor_id }} className="hover:underline"><Mono value={e.actor_id} /></Link></td>
                </tr>
              ))}
            </Table>
          )}
        </Panel>
      )}
    </Page>
  );
}

/** Link the target where the admin web has a page for it. */
function Target({ action, id }: { action: string; id: string }) {
  if (action === 'device.revoke') return <Link to="/devices/$deviceId" params={{ deviceId: id }} className="hover:underline"><Mono value={id} /></Link>;
  if (action === 'account.status' || action === 'admin.role') return <Link to="/accounts/$accountId" params={{ accountId: id }} className="hover:underline"><Mono value={id} /></Link>;
  return <Mono value={id} />;
}
